import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

const MONO_FONT = 'var(--font-plex-mono), IBM Plex Mono, monospace';

interface TradeSummaryProps {
  activeTab: 'buy' | 'sell';
  orderType: 'market' | 'limit' | 'more';
  totalCost: number;
  potReturn: number;
  potProfit: number;
}

export function TradeSummary({
  activeTab,
  orderType,
  totalCost,
  potReturn,
  potProfit,
}: TradeSummaryProps) {
  const { t } = useT();

  const rowSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    py: 1.125,
    borderTop: '1px solid',
    borderColor: 'divider',
  } as const;
  const labelSx = { fontSize: '0.84375rem', color: 'text.secondary' } as const;
  const valueSx = {
    fontFamily: MONO_FONT,
    fontSize: '0.84375rem',
    fontWeight: 600,
    color: 'success.main',
  } as const;

  return (
    <Box sx={{ mb: 0.75 }}>
      {activeTab === 'buy' ? (
        <>
          {orderType === 'limit' && (
            <Box sx={rowSx}>
              <Typography sx={labelSx}>
                {t('trade.totalCost', { defaultValue: 'Total Cost' })}
              </Typography>
              <Typography sx={{ ...valueSx, color: 'text.primary' }}>
                ${totalCost.toFixed(2)}
              </Typography>
            </Box>
          )}
          <Box sx={rowSx}>
            <Typography sx={labelSx}>
              {t('trade.youllReceive', { defaultValue: "You'll receive" })}
            </Typography>
            <Typography sx={valueSx}>${potReturn.toFixed(2)}</Typography>
          </Box>
          <Box sx={{ ...rowSx, pb: 2.25 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Typography sx={labelSx}>
                {t('trade.estimatedProfit', { defaultValue: 'To Win' })}
              </Typography>
              <InfoOutlinedIcon sx={{ fontSize: '0.875rem', color: 'text.disabled' }} />
            </Box>
            <Typography sx={valueSx}>${potProfit.toFixed(2)}</Typography>
          </Box>
        </>
      ) : (
        <Box sx={{ ...rowSx, pb: 2.25 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <Typography sx={labelSx}>
              {t('trade.youllReceive', { defaultValue: "You'll receive" })}
            </Typography>
            <InfoOutlinedIcon sx={{ fontSize: '0.875rem', color: 'text.disabled' }} />
          </Box>
          <Typography sx={valueSx}>${potReturn.toFixed(2)}</Typography>
        </Box>
      )}
    </Box>
  );
}
